import React from "react"
import Dodone from 'models/dodone'
import getModelMember from 'braindamage/api/getModelMember'
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import DodonesListItem from 'app/dodones/list/Item'
import TodayLink from 'app/dodones/shared/TodayLink'

export default ({ currentDodoneId }) => {
  // TODO: Dry with dodones/CurrentResolver.jsx
  const { isPending, data: { dodone } = {} } = useQuery({
    queryKey: ['dodone', currentDodoneId, 'next'],
    queryFn: async () => {
      const data = await getModelMember(`/api/dodones/${currentDodoneId}/next`, Dodone);
      return data;
    }
  })

  if(isPending) return null

  return <DodonesListItem dodone={ dodone } prefix="Next" />
}
